export const WORKOUT_TEMPLATE = [
  {
    id: 'bench-press',
    name: 'Bench Press',
    sets: 3,
    reps: '8-10',
    type: 'compound',
    restTime: 90,
    supersetWith: 'lat-pulldown',
    notes: null,
  },
  {
    id: 'lat-pulldown',
    name: 'Lat Pulldown',
    sets: 3,
    reps: '8-10',
    type: 'compound',
    restTime: 90,
    supersetWith: 'bench-press',
    notes: null,
  },
  {
    id: 'shoulder-press',
    name: 'Seated Shoulder Press',
    sets: 3,
    reps: '10-12',
    type: 'compound',
    restTime: 90,
    supersetWith: 'cable-row',
    notes: null,
  },
  {
    id: 'cable-row',
    name: 'Cable Row',
    sets: 3,
    reps: '10-12',
    type: 'compound',
    restTime: 90,
    supersetWith: 'shoulder-press',
    notes: null,
  },
  {
    id: 'leg-press',
    name: 'Leg Press',
    sets: 3,
    reps: '12-15',
    type: 'compound',
    restTime: 90,
    supersetWith: 'leg-curl',
    notes: '⚠️ Knee - Stop at 90°',
    warning: true,
  },
  {
    id: 'leg-curl',
    name: 'Leg Curl',
    sets: 3,
    reps: '12-15',
    type: 'compound',
    restTime: 90,
    supersetWith: 'leg-press',
    notes: null,
  },
  {
    id: 'hip-thrust',
    name: 'Hip Thrust',
    sets: 3,
    reps: '10-12',
    type: 'compound',
    restTime: 90,
    supersetWith: null,
    notes: null,
  },
  {
    id: 'tricep-pushdown',
    name: 'Cable Tricep Pushdown',
    sets: 2,
    reps: '12-15',
    type: 'isolation',
    restTime: 60,
    supersetWith: 'bicep-curl',
    notes: null,
  },
  {
    id: 'bicep-curl',
    name: 'Cable Bicep Curl',
    sets: 2,
    reps: '12-15',
    type: 'isolation',
    restTime: 60,
    supersetWith: 'tricep-pushdown',
    notes: null,
  },
  {
    id: 'plank',
    name: 'Plank',
    sets: 2,
    reps: '45-60s',
    type: 'core',
    restTime: 60,
    supersetWith: null,
    notes: null,
  },
];

export const MEAL_TEMPLATES = {
  breakfast: [
    {
      id: 'breakfast-a',
      name: '4 Eggs + Spinach + Black Beans + Salsa',
      calories: 500,
      protein: 40,
      shortName: 'Eggs & Beans',
    },
    {
      id: 'breakfast-b',
      name: '2 Scoops Whey + Almonds',
      calories: 350,
      protein: 50,
      shortName: 'Whey & Almonds',
    },
    {
      id: 'breakfast-c',
      name: 'Cottage Cheese + Lentils',
      calories: 400,
      protein: 38,
      shortName: 'Cottage & Lentils',
    },
  ],
  lunch: [
    {
      id: 'lunch-a',
      name: '250g Chicken + Broccoli + Black Beans',
      calories: 600,
      protein: 52,
      shortName: 'Chicken & Broccoli',
    },
    {
      id: 'lunch-b',
      name: '250g Ground Beef + Veg + Lentils',
      calories: 620,
      protein: 50,
      shortName: 'Beef & Lentils',
    },
    {
      id: 'lunch-c',
      name: '2 Cans Tuna + Spinach Salad + White Beans',
      calories: 550,
      protein: 55,
      shortName: 'Tuna Salad',
    },
  ],
  dinner: [
    {
      id: 'dinner-a',
      name: '250g Salmon + Asparagus + Pinto Beans',
      calories: 580,
      protein: 48,
      shortName: 'Salmon & Asparagus',
    },
    {
      id: 'dinner-b',
      name: '250g Steak + Salad + Lentils',
      calories: 600,
      protein: 52,
      shortName: 'Steak & Salad',
    },
    {
      id: 'dinner-c',
      name: '250g Chicken + Spinach + Chickpeas',
      calories: 560,
      protein: 50,
      shortName: 'Chicken & Chickpeas',
    },
  ],
  snacks: [
    {
      id: 'snack-whey',
      name: 'Whey Shake',
      calories: 120,
      protein: 24,
      shortName: 'Whey Shake',
    },
    {
      id: 'snack-almond',
      name: 'Almond Butter (1 tbsp)',
      calories: 100,
      protein: 3,
      shortName: 'Almond Butter',
    },
  ],
};

export const SUPPLEMENTS = {
  morning: [
    { id: 'nmn', name: 'NMN', dosage: '500mg', taken: false },
    { id: 'ashwagandha', name: 'Ashwagandha KSM-66', dosage: '1 cap', taken: false },
    { id: 'omega3-am', name: 'Omega 3', dosage: '2 caps', taken: false },
    { id: 'multi', name: 'Longevity Multi', dosage: 'per label', taken: false },
    { id: 'creatine', name: 'Creatine', dosage: '3g', taken: false },
    { id: 'berberine-am', name: 'Berberine', dosage: '500mg', taken: false },
  ],
  lunch: [
    { id: 'berberine-pm', name: 'Berberine', dosage: '500mg', taken: false },
  ],
  dinner: [
    { id: 'resveratrol', name: 'Resveratrol', dosage: '1 tablet', taken: false },
  ],
  bedtime: [
    { id: 'magnesium', name: 'Magnesium', dosage: '400mg', taken: false },
    { id: 'almond-butter', name: 'Almond Butter', dosage: '1 tbsp', taken: false },
  ],
  peptides: [
    { id: 'selank', name: 'Selank', dosage: '~1000mcg nasal', frequency: 'daily', taken: false },
    { id: 'bpc157', name: 'BPC-157', dosage: '250mcg subQ', frequency: 'daily', taken: false },
    { id: 'tb500', name: 'TB-500', dosage: '500-750mcg subQ', frequency: 'daily', taken: false },
  ],
};

export const CHECKLIST_ITEMS = {
  gymDay: [
    { id: 'morning-supps', label: 'Morning Supplements', category: 'supplements' },
    { id: 'breakfast-protein', label: 'Breakfast 30g+ Protein', category: 'nutrition' },
    { id: 'training-done', label: 'Training Completed', category: 'training' },
    { id: 'lunch-supps', label: 'Lunch Supplements', category: 'supplements' },
    { id: 'dinner-resveratrol', label: 'Dinner + Resveratrol', category: 'nutrition' },
    { id: 'cold-therapy', label: 'Cold Shower/Ice Pack', category: 'recovery' },
    { id: 'evening-supps', label: 'Evening Supps + Almond Butter', category: 'supplements' },
  ],
  walkDay: [
    { id: 'morning-supps', label: 'Morning Supplements', category: 'supplements' },
    { id: 'breakfast-protein', label: 'Breakfast 30g+ Protein', category: 'nutrition' },
    { id: 'walk-done', label: 'Walk Completed', category: 'training' },
    { id: 'lunch-supps', label: 'Lunch Supplements', category: 'supplements' },
    { id: 'dinner-resveratrol', label: 'Dinner + Resveratrol', category: 'nutrition' },
    { id: 'cold-therapy', label: 'Cold Shower/Ice Pack', category: 'recovery' },
    { id: 'evening-supps', label: 'Evening Supps + Almond Butter', category: 'supplements' },
  ],
  cheatDay: [
    { id: 'morning-supps', label: 'Morning Supplements', category: 'supplements' },
    { id: 'air-squats', label: '60 Air Squats Before Meals', category: 'training' },
    { id: 'cinnamon', label: '½ tsp Cinnamon Before Meals', category: 'nutrition' },
    { id: 'lunch-supps', label: 'Lunch Supplements', category: 'supplements' },
    { id: 'dinner-resveratrol', label: 'Dinner + Resveratrol', category: 'nutrition' },
    { id: 'cold-therapy', label: 'Cold Shower/Ice Pack', category: 'recovery' },
    { id: 'evening-supps', label: 'Evening Supps + Almond Butter', category: 'supplements' },
  ],
};

export const getDayType = (date, startDate) => {
  const start = new Date(startDate);
  const current = new Date(date);
  const dayNum = Math.floor((current - start) / (1000 * 60 * 60 * 24)) + 1;
  
  // Cheat day every 10 days
  if (dayNum > 0 && dayNum % 10 === 0) {
    return 'cheat';
  }
  
  const dayOfWeek = current.getDay();
  // Mon=1, Wed=3, Fri=5 are gym days
  if (dayOfWeek === 1 || dayOfWeek === 3 || dayOfWeek === 5) {
    return 'gym';
  }
  
  // All other days are walk days
  return 'walk';
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
};

export const getDateString = (date = new Date()) => {
  return date.toISOString().split('T')[0];
};
